import Carousel from "nuka-carousel";
import React, {useEffect, useRef, useState} from "react";
import {H2} from "BaseComponents/Text";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";
import {useObserver} from "Hooks/useObserver";
import {GetTextColor} from "Helpers/ColorHelper";
import {CarouselControl} from "BaseComponents/Button";
import {WrapperControls} from "BaseComponents/Wrappers";

import {
    HeaderWrapper,
    Icon,
    IconWrapper,
    ImageWrapper,
    SliderWrapper,
    SlideShowInnerWrapper,
    SlideShowWrapper,
} from "./components";
import useBreakpoint from "Hooks/useBreakpoint";

export const SlideShow = ({
                              Heading,
                              Images,
                              BackgroundColor,
                              FacebookLink,
                              InstagramLink,
                          }) => {
    const [openModal, setOpenModal] = useState(false);
    const [currentSlide, setCurrentSlide] = useState(0);
    const [isVisible, setVisible] = useState(false);
    let slidesToShow = 2;
    slidesToShow = useBreakpoint("mobile") ? 1.2 : slidesToShow;
    const domRef = useRef();
    const observe = useObserver(domRef);
    useEffect(() => {
        if (!isVisible && observe) {
            setVisible(true);
        }
    }, [observe]);
    useEffect(() => {
        if (openModal) {
            document.body.classList.add("modal-no-scroll");
        } else {
            document.body.classList.remove("modal-no-scroll");
        }
    }, [openModal]);

    const handleModal = (image, i, e) => {
        setOpenModal(!openModal);
        setCurrentSlide(i);
    };
    const handleKeyPress = (image, i, e) => {
        if (e.key === "Enter" || e.key === " ") {
            handleModal(image, i);
        }
    };

    const {textColor} = GetTextColor(BackgroundColor);

    return (
        <SlideShowWrapper
            ref={domRef}
            notFirstSlide={currentSlide != 0}
            bgColor={BackgroundColor}
        >
            <SlideShowInnerWrapper>
                <HeaderWrapper>
                    <H2
                        color={textColor}
                        inline
                        margin="0 0 2rem 0"
                        marginsmall="0 0 1rem 0"
                    >
                        {Heading}
                    </H2>
                    <IconWrapper hoverColor={textColor}>
                        {FacebookLink && (
                            <a target="_blank" href={FacebookLink}>
                                <Icon className="icon-facebook"></Icon>
                            </a>
                        )}
                        {InstagramLink && (
                            <a target="_blank" href={InstagramLink}>
                                <Icon className="icon-instagram"></Icon>
                            </a>
                        )}
                    </IconWrapper>
                </HeaderWrapper>

                {openModal && (
                    <Lightbox
                        mainSrc={Images[currentSlide]}
                        nextSrc={Images[(currentSlide + 1) % Images.length]}
                        prevSrc={
                            Images[(currentSlide + Images.length - 1) % Images.length]
                        }
                        onCloseRequest={() => setOpenModal(false)}
                        onMovePrevRequest={() =>
                            setCurrentSlide(
                                (currentSlide + Images.length - 1) % Images.length
                            )
                        }
                        onMoveNextRequest={() =>
                            setCurrentSlide(
                                (currentSlide + Images.length + 1) % Images.length
                            )
                        }
                    />
                )}

                {Images.length > 0 && (
                    <SliderWrapper
                        showButtons={Images.length < 8}
                        notFirstSlide={currentSlide != 0}
                    >
                        <Carousel
                            renderCenterLeftControls={() => null}
                            renderCenterRightControls={() => null}
                            heightMode="first"
                            slidesToShow={slidesToShow}
                            afterSlide={(slideIndex) => setCurrentSlide(slideIndex)}
                            scrollMode="page"
                            speed={150}
                            slideWidth={1}
                            easing="easeLinear"
                            renderBottomCenterControls={({
                                                             previousSlide,
                                                             nextSlide,
                                                             currentSlide,
                                                             slideCount,
                                                             ...rest
                                                         }) => {

                                const leftIsDisabled = currentSlide === 0;
                                const rightIsDisabled = currentSlide + slidesToShow === slideCount;                                
                                return (
                                    <WrapperControls>
                                        <CarouselControl onClick={previousSlide} isDisabled={leftIsDisabled}>
                                            <i className="fa fa-arrow-left"/>
                                        </CarouselControl>
                                        <CarouselControl onClick={nextSlide} isDisabled={rightIsDisabled}>
                                            <i className="fa fa-arrow-right"/>
                                        </CarouselControl>
                                    </WrapperControls>
                                );
                            }}
                        >
                            {isVisible &&
                                Images.map((image, i) => (
                                    <ImageWrapper
                                        onClick={() => handleModal(image, i)}
                                        bgImage={image}
                                        onKeyDown={(e) => handleKeyPress(image, i, e)}
                                        key={`slide-show-image-${i}`}
                                    />
                                ))}
                        </Carousel>
                    </SliderWrapper>
                )}
            </SlideShowInnerWrapper>
        </SlideShowWrapper>
    );
};
